namespace NasVault {
  export interface Item {
    name: string;
    type: "folder" | "file";
    size: number;
    modifiedAt: string | null;
    contentType?: string | null;
  }

  export interface ListPayload {
    ok: boolean;
    path?: string;
    items?: Item[];
    canWrite?: boolean;
    deleteEnabled?: boolean;
    error?: string;
  }

  export interface UploadResult {
    ok: boolean;
    path?: string;
    error?: string;
  }

  export type UploadState = "waiting" | "uploading" | "success" | "error";
}
